module.exports = {
  "zones": {
    "Australia/Tasmania": ["z", {
      "wallclock": -94694400000,
      "format": "AE%sT",
      "abbrev": "AEST",
      "offset": 36000000,
      "posix": -94730400000,
      "save": 0,
      "rules": "AT"
    }, {
      "wallclock": -1669852800000,
      "format": "AE%sT",
      "abbrev": "AEDT",
      "offset": 36000000,
      "posix": -1669892400000,
      "save": 3600000,
      "rules": "Aus"
    }, {
      "wallclock": -1680472800000,
      "format": "AEDT",
      "abbrev": "AEDT",
      "offset": 36000000,
      "posix": -1680508800000,
      "save": 3600000
    }, {
      "wallclock": -2345760000000,
      "format": "AEST",
      "abbrev": "AEST",
      "offset": 36000000,
      "posix": -2345795356000,
      "save": 0
    }, {
      "wallclock": -1.7976931348623157e+308,
      "format": "LMT",
      "abbrev": "LMT",
      "offset": 35356000,
      "posix": -1.7976931348623157e+308,
      "save": 0
    }]
  },
  "rules": {
    "AT": [{
      "from": 2001,
      "to": 1.7976931348623157e+308,
      "month": 9,
      "day": [0, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 2008,
      "to": 1.7976931348623157e+308,
      "month": 3,
      "day": [0, 1],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 2007,
      "to": 2007,
      "month": 2,
      "day": [0, -31],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 2006,
      "to": 2006,
      "month": 3,
      "day": [0, 1],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1991,
      "to": 2005,
      "month": 2,
      "day": [0, -31],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 2000,
      "to": 2000,
      "month": 7,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1991,
      "to": 1999,
      "month": 9,
      "day": [0, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1987,
      "to": 1990,
      "month": 2,
      "day": [0, 15],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1988,
      "to": 1990,
      "month": 9,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1987,
      "to": 1987,
      "month": 9,
      "day": [0, 22],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1984,
      "to": 1986,
      "month": 2,
      "day": [0, 1],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1986,
      "to": 1986,
      "month": 9,
      "day": [0, 15],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1968,
      "to": 1985,
      "month": 9,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1982,
      "to": 1983,
      "month": 2,
      "day": [0, -31],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1973,
      "to": 1981,
      "month": 2,
      "day": [0, 1],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1972,
      "to": 1972,
      "month": 1,
      "day": [0, -29],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1969,
      "to": 1971,
      "month": 2,
      "day": [0, 8],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1968,
      "to": 1968,
      "month": 2,
      "day": [0, -31],
      "time": 180,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1967,
      "to": 1967,
      "month": 9,
      "day": [0, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }],
    "Aus": [{
      "from": 1943,
      "to": 1944,
      "month": 2,
      "day": [0, -31],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1943,
      "to": 1943,
      "month": 9,
      "day": [7, 3],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1942,
      "to": 1942,
      "month": 0,
      "day": [7, 1],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1942,
      "to": 1942,
      "month": 2,
      "day": [7, 29],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }, {
      "from": 1942,
      "to": 1942,
      "month": 8,
      "day": [7, 27],
      "time": 120,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1917,
      "to": 1917,
      "month": 0,
      "day": [7, 1],
      "time": 1,
      "clock": "wallclock",
      "save": 60,
      "letter": "D",
      "saved": 0
    }, {
      "from": 1917,
      "to": 1917,
      "month": 2,
      "day": [7, 25],
      "time": 120,
      "clock": "wallclock",
      "save": 0,
      "letter": "S",
      "saved": 3600000
    }]
  }
};